import React from 'react';
import { Link } from 'operation-diameter';

export default {
  heading: 'Adjust your client’s offer',
  submit: {
    label: 'Update offer'
  },
  commission: {
    heading: 'How much would you like your commission amount to be?',
    label: 'Amount',
    helperText: {
      pristine: 'This is the same as your current commission amount'
    },
    errors: {
      oneOf: 'Please select a commission amount'
    }
  },
  loanAmount: {
    heading: 'How much would your client like to borrow?',
    label: 'Amount',
    helpText: 'Your client can borrow from {{minAmount}} to {{maxAmount}}'
  },
  term: {
    legend: 'How long would your client like to borrow for?'
  },
  contactUs: () => (
    <>
      <strong>
        Want to increase the amount your client would like to borrow, or
        decrease their term?
      </strong>{' '}
      Give us a call at <Link href='tel:0800 048 2467'>0800 048 2467</Link> or
      email us at{' '}
      <Link href='mailto:credit@fundingcircle.com'>
        credit@fundingcircle.com
      </Link>
      . Your Business Development Manager will be happy to help you.
    </>
  )
};
